import PropTypes from "prop-types";
import { useCallback, useMemo } from "react";

import styled from "styled-components/macro";

import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";
import { useAccentColor } from "Giving/ManageMyGivingPage/stateHooks";
import TwoFA from "Login/TwoFA";
import { variants } from "Login/TwoFA/constants";
import classNames from "classnames";

import FundItLogo from "UI/images/FundItLogo";

import useColorSchemeIsLight from "../stateHooks/useColorSchemeIsLight";
import { useFetchLandingPageData } from "../useFetchLandingPageData";

ManageMyGivingPageAuth.propTypes = {
  isMobile: PropTypes.bool,
};

export default function ManageMyGivingPageAuth({ isMobile }) {
  const { setState } = useManageMyGivingPage();
  const accentColor = useAccentColor();
  const isLight = useColorSchemeIsLight();

  const fetchLandingPageData = useFetchLandingPageData();

  const handleAuthSuccess = useCallback(
    ({ userID }) => {
      setState({ userID });
      fetchLandingPageData();
    },
    [fetchLandingPageData, setState]
  );

  const className = useMemo(() => classNames({ mobile: isMobile }), [isMobile]);

  const isDark = useMemo(() => {
    if (isMobile) return isLight;
    return !isLight;
  }, [isLight, isMobile]);

  return (
    <OuterWrapper className={className}>
      <Wrapper>
        <Header>
          <Logo>
            <FundItLogo size={80} color={accentColor} />
          </Logo>
          <Text>
            Enter your email or phone below to view your giving data.
            <Subtext>
              Or to make a gift, click the <em>Make a Gift</em> button{" "}
              {isMobile ? "above" : "to the left"}.
            </Subtext>
          </Text>
        </Header>
        <AuthWrapper>
          <TwoFA
            variant={variants.mmg}
            onSuccess={handleAuthSuccess}
            accentColor={accentColor}
            width="100%"
            headerText={false}
            showNetwork={false}
            isDark={isDark}
            stoutInputs
          />
        </AuthWrapper>
      </Wrapper>
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 20px;
  padding-right: 0;
  box-sizing: border-box;
  color: var(--textPrimary);
  border-radius: 24px;
  ${OuterWrapper}.mobile & {
    max-width: 520px;
    padding-right: 20px;
    background: red;
    margin-bottom: 40px;
    background: linear-gradient(
      140deg,
      var(--bgGradient1) 0%,
      var(--bgGradient2) 100%
    );
    color: #fff;
  }
`;
const Header = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 30px;
  padding-bottom: 30px;
  ${OuterWrapper}.mobile & {
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
`;
const Logo = styled.div``;
const Text = styled.div`
  font-size: 20px;
  font-weight: 400;
`;
const Subtext = styled.div`
  font-size: 16px;
  padding-top: 8px;
`;
const AuthWrapper = styled.div`
  ${OuterWrapper}.mobile & {
    padding-left: 5px;
  }
`;
